<template>
    <div class="work-in-progress-overlay">
        <div class="content">
            <vx-basic-icon icon="CoffeeIcon" class="icon" />
            <div class="text1">Work In</div>
            <div class="text2 flex justify-center items-center">Progress</div>
            <div class="card-slot">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'vx-work-in-progress',
    props: {
        message: {
            type: String
        }
    }
}
</script>

<style scoped>
.work-in-progress-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(19, 19, 19, 0.7);
    z-index: 999;
}

.icon {
    height: 4rem;
    width: 5rem;
    /* size="16" */
}

.text1 {
    color: rgba(var(--vs-primary), 1);
    text-transform: uppercase;
    font-size: calc(15px + 2vw);
    font-weight: 900;
}
.text2 {
    background-color: rgba(var(--vs-primary), 1);
    color: black;
    text-transform: uppercase;
    font-size: calc(12px + 2vw);
    font-weight: 900;
    padding-left: 0.2em;
    padding-right: 0.2em;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.card-slot {
    margin-top: 1em;
    width: 100%;
    max-width: 600px;
    display: flex;
    justify-content: center;
}
</style>
